import {
    TableCell,
    TableRow,
    Theme,
    Typography
} from "@mui/material";
import { PerformersData } from "../types";

export default function DataTable(
    { data }: { data: PerformersData[]; },
    index: number
): JSX.Element {
    return (
        <>
            {data.map((obj: PerformersData) => {
                const returnValue = !Number.isNaN(Number(obj?.return ?? 0)) ?
                    Math.round(Number(obj?.return ?? 0) * 100) / 100 : 0

                const folioCheck = obj?.folioNo !== '0' ? `(${obj?.folioNo})` : ''

                return (
                    <TableRow
                        key={`${obj?.schemeName}-${index}`}
                        sx={(theme: Theme) => ({
                            '& td': {
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            },
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        })}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                })}
                            >
                                {obj?.schemeName ? (`${obj?.schemeName}${folioCheck}`) : "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.category ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.fundHouse ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: returnValue >= 0 ? theme.palette.success[800] : theme.palette.error[500]
                                })}
                            >
                                {returnValue} %
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {!Number.isNaN(Number(obj?.exposure ?? 0)) ?
                                    Math.round((obj?.exposure ?? 0) * 100) / 100 : '0'}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}